

/**
 * @name NewCollectorModalController
 * @description Function to handle operator invite cancellations
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} collector Resolved collector from the invitation controller
 * @param {unknown} token Resolved token from the invitation controller
 * @param {unknown} InvitationFactory The Invitation service
 * @param {unknown} CheckUsername The CheckUsername service
 */
function NewCollectorModalController(
  $uibModalInstance,
  collector,
  token,
  InvitationFactory,
  CheckUsername
) {
  let vm = this;
  vm.collector = collector;
  vm.token = token;
  vm.updateAccount = updateAccount;
  vm.checkUsername = checkUsername;

  // Defaults
  vm.required = false;

  /**
   * @description Update the collector if one is a new user
   * @param {object} profile The collector profile to update
   */
  function updateAccount(profile) {
    let newProfile = {
      token: vm.token,
      username: profile.username,
      firstName: profile.first_name,
      lastName: profile.last_name,
      phone: profile.phone,
      password: profile.password,
      profile_photo: profile.profile_photo
    };
    InvitationFactory.updateAccount(newProfile).then(function(invitation) {
      $uibModalInstance.close(invitation.collector);
    });
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentUsername)
    .then(function(results) {
      vm.usernameResults = results;
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('NewCollectorModalController', NewCollectorModalController);



// WEBPACK FOOTER //
// ./components/invitation/new-collector-modal.controller.js